import { render, staticRenderFns } from "./chart-of-account.vue?vue&type=template&id=6cb07660&"
import script from "./chart-of-account.vue?vue&type=script&lang=js&"
export * from "./chart-of-account.vue?vue&type=script&lang=js&"
import style0 from "./chart-of-account.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VProgressCircular,VRow,VSimpleTable})
